<template>
    <div class="arrowBox">
        <div ref="arrow">
            <v-icon :color="color" size="30">mdi-navigation</v-icon>
        </div>
    </div>
</template>

<script>

    import {TweenLite, Expo} from 'gsap';

    export default {

        components: {},

        props: {
            angle: {
                type: Number,
                required: true,
            },
            color: {
                type: String,
                required: false,
                default: 'grey lighten-1',
            }
        },

        watch: {
            angle() {
                this.tween();
            }
        },

        data() {
            return {
                animationCompleted: true,
            }
        },

        mounted() {
            this.tween(this.angle);
        },

        methods: {
            randomNumber(min, max) {
                return Math.floor(Math.random() * (+max - +min)) + +min;
            },
            tween() {
                if (this.animationCompleted) {
                    this.animationCompleted = false;
                    TweenLite.to(this.$refs.arrow, 1, {
                        transformOrigin:"50% 50%",
                        rotation: this.angle + this.randomNumber(-2, 2),
                        y: 0,
                        x: 0,
                        scaleX: 1,
                        ease: Expo.easeOut
                    }).eventCallback('onComplete', () => {
                        this.animationCompleted = true;
                    });
                }
            }
        }
    }
</script>

<style scoped>
    .arrowBox {
        vertical-align:middle;
        display: inline-block;
        width: 40px;
        height: 40px;
    }
</style>
